export interface Port {
  id: number;
  operator: string;
  port: string;
}

export type PortPayload = Omit<Port, "id">;

export type PortFormErrors = Partial<Record<keyof PortPayload, string>>;

export interface PortsApiResponse {
  success: boolean;
  data: Port[];
}

export const PORT_OPERATORS = [">", "<", "="];

export const PORT_FIELDS: Array<keyof PortPayload> = ["operator", "port"];

export const emptyPort: PortPayload = {
  operator: "",
  port: "",
};
